export function iOSPushPermissionRequest() {
    window.webkit.messageHandlers['push-permission-request'].postMessage('push-permission-request');
}

export function getIOSPushToken() {
    window.webkit.messageHandlers['push-token'].postMessage('push-token');
}

export function iOSPushCapability() {
    return window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers['push-permission-request'] && window.webkit.messageHandlers['push-permission-state'];
}

export function getIOSPushPermissionState() {
    window.webkit.messageHandlers['push-permission-state'].postMessage('push-permission-state');
}